import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const ProductWidgetGridLayoutStyle = styled.div`
  width: 100%;

  .slick-dots {
    position: static;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    height: 8px;

    li {
      margin: 0;
      width: 8px;
      height: 8px;

      &:not(:last-child) {
        margin-right: 6px;
      }

      button {
        width: 0;
        height: 0;
        padding: 0;
        display: inline-block;

        &:before {
          width: 0;
          height: 8px;
          line-height: 8px;
        }
      }
    }
  }

  .amondz-slider > .slick-list > .slick-track > .slick-slide > div > span {
    display: block !important;
  }
`;
